import { useEffect } from "react";
import { useState } from "react";
import { getIgo } from "../../HTTP/translation";
import { countries } from "../../global/countriesAndSources";

export default function Igo() {
    const [searchTerm, setSearchTerm] = useState("");

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    }

    const [igo, setIgo] = useState([]);
    const [igoReady, setIgoReady] = useState(false);

    useEffect(() => {
        const fetchIgo = async () => {
            try {
                const response = await getIgo();
                console.log(response);
                setIgo(response);
            } catch (error) {
                console.error("Error fetching IGOs:", error);
            }
        }
        fetchIgo();
        setIgoReady(true);
    }, []);

    const parseCountryListIgo = (countryList) => {
        const countriesArray = countryList.split(",").map(country => country.trim());
        const final = countriesArray.map(country => {
            const countryData = countries.find(c => c.code === country);
            return countryData ? countryData.name : country;
        }).join(", ");
        return final.length > 150 ? final.slice(0, 150) + "..." : final;
    }

    const filteredIgo = igo
        .filter(igoElement =>
            igoElement.label &&
            igoElement.country_list &&
            igoElement.link &&
            igoElement.label.trim() !== "" &&
            igoElement.country_list.trim() !== "" &&
            igoElement.link.trim() !== ""
        )
        .filter(igoElement => {
            const label = igoElement.label ? igoElement.label.toLowerCase() : "";
            const description = igoElement.description ? igoElement.description.toLowerCase() : "";
            const countryList = igoElement.country_list ? parseCountryListIgo(igoElement.country_list).toLowerCase() : "";
            return (
                label.includes(searchTerm.toLowerCase()) ||
                description.includes(searchTerm.toLowerCase()) ||
                countryList.includes(searchTerm.toLowerCase())
            );
        });

    const handleIgo = (igoElement) => {
        sessionStorage.setItem("search_igo", igoElement.name);
        // get formated link without https and www and the slash at the end
        const formattedLink = igoElement.link.replace(/^(https?:\/\/)?(www\.)?/, "").replace(/\/$/, "");
        sessionStorage.setItem("search_query", formattedLink);
        sessionStorage.setItem("search_country",JSON.stringify(countries.find(c => c.code === 'wd')))
        window.location.href = "/?igo=" + igoElement.name;
    }

    return (
        <>
        <section className="articlesfav">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Rechercher parmi les OIG..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-input"
            />
        </div>


            <div className="allArticlesDiv h-100 overflow-y-auto" style={{ maxHeight: "calc(100vh - 200px)" }}>
            {
              igoReady && filteredIgo.map((igoElement, i) => (
                    <div className="featuresfav" key={i} id={`fav_${i}`}>
                        <div className="itemfav rounded-lg shadow m-2" data-id={i}>
                          <div  className="item-photowrapper">
                              <img
                                  className="item-photofav"
                                  src={(igoElement.image || process.env.PUBLIC_URL + "/favicon.png") /**  IMAGE  */}
                                  alt="article"
                                  onClick={() => window.open((igoElement.link), "_blank")} 
                                />
                          </div>
                          <div className="arttfav">
                            <div className="item-headerfav">
                              
                            </div>
                            <button onClick={() => handleIgo(igoElement)} style={{ textDecoration: "inherit", color: "inherit" }}>
                              <h3 className="item-titlefav">
                                  {(igoElement.label) }
                              </h3>
                              <p className="item-textfav"><strong className="text-cyan-600">
                                  Pays : {parseCountryListIgo(igoElement.country_list)} 
                                </strong></p> 
                            </button>

                          </div>
                        </div>
                    </div>
              ))
            }
            </div>

        </section>
        
        </>
    );
}